import { render, staticRenderFns } from "./AcademicPlant.html?vue&type=template&id=1debe988&scoped=true&"
import script from "./AcademicPlant.vue?vue&type=script&lang=js&"
export * from "./AcademicPlant.vue?vue&type=script&lang=js&"
import style0 from "./AcademicPlant.scss?vue&type=style&index=0&id=1debe988&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1debe988",
  null
  
)

export default component.exports